import { Component, inject } from "@angular/core";
import { ZoneStore } from "@app/services/store/zone-store";
import { ResourceZoneStore } from "@app/services/store/resource-zone-store";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from "@angular/material/dialog";
import { Zone } from "@app/models/rest/zone";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { NgxUiLoaderService, NgxUiLoaderModule } from "ngx-ui-loader";
import { ZoneDeleteConfirmDialogComponent } from "@app/view/setup/resourcing/zone/zone-delete-confirm-dialog/zone-delete-confirm-dialog.component";
import { MatButton } from "@angular/material/button";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { ColorPickerDirective } from "ngx-color-picker";
import { TranslatePipe } from "@ngx-translate/core";
import { DialogHeaderComponent } from "../../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-zone-edit-overlay",
  templateUrl: "./zone-edit-overlay.component.html",
  styleUrls: ["./zone-edit-overlay.component.scss"],
  imports: [
    NgxUiLoaderModule,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    ColorPickerDirective,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    TranslatePipe,
    DialogHeaderComponent
  ]
})
export class ZoneEditOverlayComponent {
  zoneStore = inject(ZoneStore);
  ngxLoader = inject(NgxUiLoaderService);
  resourceZoneStore = inject(ResourceZoneStore);
  dialogRef = inject<MatDialogRef<ZoneEditOverlayComponent>>(MatDialogRef);
  dialog = inject(MatDialog);
  data = inject<{
    zone: Zone;
  }>(MAT_DIALOG_DATA);

  public zoneForm: UntypedFormGroup;
  fillColour: any;
  strokeColour: any;

  constructor() {
    const fb = inject(UntypedFormBuilder);
    const data = this.data;

    this.zoneForm = fb.group({
      name: "",
      ordinal: null
    });
    if (data.zone) {
      this.zoneForm.setValue({
        name: data.zone.name,
        ordinal: data.zone.ordinal
      });

      this.strokeColour = data.zone.foregroundColor;
      this.fillColour = data.zone.backgroundColor;
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  public notifyChange(newWKT: string) {
    console.log("got change", newWKT);
    this.data.zone.area = newWKT;
    this.zoneForm.markAsDirty();
  }

  save() {
    this.ngxLoader.startLoader("zoneEditLoader");

    this.data.zone.name = this.zoneForm.value.name;
    this.data.zone.ordinal = this.zoneForm.value.ordinal;
    this.data.zone.backgroundColor = this.fillColour;
    this.data.zone.foregroundColor = this.strokeColour;
    console.log(this.data.zone);
    this.zoneStore.update(this.data.zone).subscribe(
      (value: Zone) => {
        this.data.zone = value;
        this.ngxLoader.stopLoader("zoneEditLoader");
        this.dialogRef.close();
      },
      (error) => {}
    );
  }

  colourChanged() {
    this.zoneForm.markAsDirty();
  }

  onDeleteClick() {
    let deleteDialog = this.dialog.open(ZoneDeleteConfirmDialogComponent, {});
    deleteDialog.afterClosed().subscribe((value) => {
      if (value === true) {
        this.zoneStore.delete(this.data.zone).subscribe((value1) => {
          this.dialogRef.close();
        });
      }
    });
  }
}
